import * as Yup from 'yup';
import { useTranslator } from '../translation/useTranslator';

export const usePasswordSchemas = () => {
  const t = useTranslator();

  const NpsTodayPasswordSchema = Yup.string()
    .required(t.passwordConfirmRequired)
    .min(8, t.passwordMinLength)
    .matches(/\d/, t.passwordNumberRequired)
    .matches(/[a-z]/, t.passwordLowercaseRequired)
    .matches(/[A-Z]/, t.passwordUppercaseRequired);

  const ResetPasswordSchema = Yup.object({
    newPassword: NpsTodayPasswordSchema,
    confirmNewPassword: Yup.string()
      .required(t.passwordConfirmRequired)
      .oneOf([Yup.ref('newPassword')], t.passwordMatch)
  });

  const ChangePassWordSchema = ResetPasswordSchema.shape({
    oldPassword: Yup.string().required(t.passwordOldRequired)
  });

  const SignUpSchema = ResetPasswordSchema.shape({
    email: Yup.string().email(t.emailInvalid).required(t.emailRequired)
  });

  const LoginSchema = Yup.object({
    email: Yup.string().email(t.emailInvalid).required(t.emailRequired),
    password: Yup.string().required(t.passwordConfirmRequired),
    isTwoFactorAuthEnabled: Yup.boolean(),
    twoFactorCode: Yup.string().when('isTwoFactorAuthEnabled', {
      is: true,
      then: Yup.string().required(t.twoFactorRequired).length(6, t.twoFactorLength)
    })
  });

  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string().email(t.emailInvalid).required(t.emailRequired)
  });

  return {
    NpsTodayPasswordSchema,
    ChangePassWordSchema,
    ResetPasswordSchema,
    SignUpSchema,
    LoginSchema,
    ForgotPasswordSchema
  };
};
